<template>
	<div>
		<div style="margin:15px 0">
			<!-- 面包屑 -->
			<el-breadcrumb separator-class="el-icon-arrow-right">
				<el-breadcrumb-item :to="{ path: '/cardList' }">明信片管理</el-breadcrumb-item>
				<el-breadcrumb-item>{{ type === 0 ? '添加' : '编辑' }}明信片</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<el-form :rules="rules" :model="formList" ref="formList">
			<el-card class="box-card">
				<el-form-item label="商品名称：" prop="name" label-width="100">
					<el-input style="width: 80%;" v-model.trim="formList.name" placeholder="请输入商品名称"></el-input>
				</el-form-item>
				<el-form-item label="商品简介：" prop="brief" label-width="100">
					<el-input type="textarea" :autosize="{ minRows: 5}" style="width: 80%;" v-model="formList.brief" placeholder="请输入商品简介"></el-input>
				</el-form-item>
				<el-form-item label="商品价格：" prop="retail_price" label-width="100">
					<el-input-number style="width: 300px;" v-model.number="formList.retail_price" :precision="2"
									 :min="0.01" :step="1"></el-input-number>
				</el-form-item>
				<el-form-item label="明信片大小：" prop="photo_width" label-width="100">
					<span>宽比：</span>
					<el-input-number v-model.number="formList.photo_width" :precision="0"
									 :min="1" :step="1"></el-input-number>
					<span>高比：</span>
					<el-input-number v-model.number="formList.photo_height" :precision="0"
									 :min="1" :step="1"></el-input-number>
				</el-form-item>
				<el-form-item label="轮播图片" prop="gallery" v-loading="loadImg" label-width="100">
					<el-upload class="avatar-uploader" list-type="picture-card" :file-list="formList.gallery"
							   :action="uploadPath"
							   :before-upload="upLoadBefore"
							   :on-remove="imgRemove"
							   :on-error="upLoadError"
							   :on-success="upLoadSuccess">
						<i class="el-icon-plus"></i>
					</el-upload>
					<span>图片大小建议，850像素*850像素，且不超过1M</span>
				</el-form-item>
				<el-form-item label="商品详情：" prop="detail" label-width="100">
					<editor v-model="formList.detail" :init="editorInit"/>
				</el-form-item>
			</el-card>
		</el-form>
		<div class="footer-btns">
			<el-button @click="cancel">取 消</el-button>
			<el-button type="primary" @click="save">保 存</el-button>
		</div>
	</div>
</template>

<script>
import {request, postcardPutObject} from "../../axios/index";
import api from "../../api/card";
import Editor from '@tinymce/tinymce-vue';

export default {
	components: {Editor},
	props: {
		pageSize: {
			type: Number,
			default: 10,
		}
	},
	data() {
		return {
			uploadPath: postcardPutObject,
			loadImg: false,
			formList: {
				id: undefined,
				photo_width: 3,
				photo_height: 2,
				name: '',//商品名称
				gallery: [],//商品宣传图片
				brief: '',//商品简介
				retail_price: 1,
				detail: '',//商品详细介绍
				is_on_sale: 0
			},
			rules: {
				name: [{required: true, message: '请填写商品名称', trigger: 'blur'}],
				gallery: [{required: true, message: '请上传商品宣传图', trigger: 'change'}],
				brief: [{required: true, message: '请填写商品简介', trigger: 'blur'}],
				retail_price: [{required: true, message: '请填写商品价格', trigger: 'blur'}],
				detail: [{required: true, message: '请填写商品详情', trigger: 'blur'}],
			},
			editorInit: {
				language: 'zh_CN',
				height: '400px',
				convert_urls: false,
				plugins: [
					'advlist anchor autolink autosave code codesample colorpicker colorpicker contextmenu directionality emoticons fullscreen hr  imagetools importcss insertdatetime link lists media nonbreaking noneditable pagebreak paste preview print save searchreplace spellchecker tabfocus table template textcolor textpattern visualblocks visualchars wordcount image'
				],
				toolbar: [
					'searchreplace bold italic underline strikethrough alignleft aligncenter alignright outdent indent  blockquote undo redo removeformat subscript superscript code codesample',
					'hr bullist numlist  charmap preview anchor pagebreak insertdatetime media table emoticons forecolor backcolor fullscreen image'
				],
				images_upload_handler: function (blobInfo, success, failure) {
					const formData = new FormData()
					formData.append('file', blobInfo.blob());
					request({
						url: postcardPutObject,
						method: 'post',
						data: formData
					}).then(res => {
						success(res)
					}).catch(() => {
						failure('上传失败，请重新上传')
					})
				}
			},
			type: 0
		}
	},
	mounted() {
		let query = this.$route.query;
		this.type = query.type;
		if (this.type === 1) {
			this.formList = this.$datas.postcard;
		}
	},
	methods: {
		save() {//保存
			let form = Object.assign({}, this.formList);
			this.$refs.formList.validate(valid => {
				if (!valid) return false;
				form.gallery = this.formList.gallery.map(v => v.url);
				form.gallery = JSON.stringify(form.gallery);
				if (this.type === 0) {
					api.addPostcard(form).then(res => {
						this.cancel();
					}).catch(err => {
						this.$message({
							type: 'error',
							message: err.msg
						});
					})
				} else {
					api.updatePostcard(form).then(res => {
						this.cancel();
					}).catch(err => {
						this.$message({
							type: 'error',
							message: err.msg
						});
					})
				}
			})
		},
		cancel() {
			this.$router.push({
				path: "/cardList"
			});
		},
		imgRemove(e) {
			this.formList.gallery.splice(this.formList.gallery.indexOf(e),1);
		},
		upLoadBefore(res) {
			this.loadImg = true;
		},
		upLoadError(err) {
			this.$message({
				type: 'error',
				message: '上传出错'
			});
			this.loadImg = false;
		},
		upLoadSuccess(res, file) {//上传图片
			if (res.code === 0) {
				this.formList.gallery.push({url: res.data});
				this.loadImg = false;
			}
		},
	},
}
</script>

<style>
p span {
	margin: 0 25px;
}

.avatar-uploader .el-upload {
	border: 1px dashed #d9d9d9;
	border-radius: 6px;
	cursor: pointer;
	position: relative;
	overflow: hidden;
}

.avatar-uploader .el-upload:hover {
	border-color: #409EFF;
}

.avatar-uploader-icon {
	font-size: 28px;
	color: #8c939d;
	width: 120px;
	height: 120px;
	line-height: 120px;
	text-align: center;
}

.avatar {
	width: 120px;
	height: 120px;
	display: block;
}

.el-radio.is-bordered {
	padding-right: 10px;
}

.footer-btns {
	padding: 10px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/card/postcard.vue